define('front-tracking',['underscore', 'pulse', 'track-visibility'], function(_, Pulse, trackVisibility) {
    var SELECTOR_ELEMENT = '.article-extract';
    var BRAND_MAP = {
        'e24.no': 'e24',
        'shifter.no': 'shifter',
        'dinepenger.no': 'dinepenger',
        'aksjelive.e24.no': 'aksjelive',
        'tek.no': 'tekno'
    };
    var TEASER_SIZES = [
        ['article-extract-full', '1.0'],
        ['article-extract-three-fourth', '0.75'],
        ['article-extract-three-fifths', '0.6'],
        ['article-extract-half', '0.5'],
        ['article-extract-two-fifths', '0.4'],
        ['article-extract-one-third', '0.33'],
        ['article-extract-one-fourth', '0.25']
    ];

    var elementQueue = [];
    var SAMPLE_SIZE = 100;
    var CLICK_TRACKING_ID = 'Teaser'; // This passes to LinkPulse
    var VIEW_TRACKING_ID = 'FrontTracking'; // This intentionally does not

    var startTime = Date.now();

    function getScrollPosition() {
        var offset = window.pageYOffset || document.scrollTop || 0;
        var clientOffset = document.clientTop || 0;

        return Math.floor(offset - clientOffset);
    }

    function mapScrollPosition(elements, scrollPosition) {
        return elements.map(function (element) {
            return Object.assign({}, element, {
                scrollPosition: scrollPosition
            });
        });
    }

    function getTargetTypeFromLink(link) {
        if (link.hostname.indexOf('vgtv.no') > -1) {
            return 'Video';
        }

        return 'Article';
    }

    function getAccessLevelFromElement(element) {
        var image = element.querySelector('.df-img-container');

        if (image && image.className.indexOf('df-img-skin-e24pluss') > -1) {
            return 'Paid';
        }

        return 'Free';
    }

    function getBrand(brand) {
        if (brand in BRAND_MAP) {
            return BRAND_MAP[brand];
        }

        if (!brand) {
            return 'e24';
        }

        return brand;
    }

    function getElementTargetData(element) {
        var link = element.querySelector('a');

        if (!link) {
            return;
        }

        var brand = getBrand(link.hostname);
        var targetType = getTargetTypeFromLink(link);
        var targetId = link.pathname.replace(/^.*\/i\/([^\/]+)\/.*$/, '$1');
        var accessLevel = getAccessLevelFromElement(element);

        if (!targetId) {
            if (link.pathname.includes('/article/') && brand === 'aksjelive') {
                targetId = link.pathname.replace(/^.*\/article\/([^\/]+)\/.*$/, '$1');
            } else if (link.pathname.includes('/spesial/')) {
                targetId = 'spesial';
            } else {
                targetId = 'noid';
            }
        }

        var id = 'sdrn:' + brand + ':' + targetType.toLowerCase() + ':' + targetId;

        return {
            '@id': id,
            '@type': targetType,
            name: '',
            category: 'News',
            url: link.href,
            article_access_level: accessLevel
        };
    }

    function getElementObjectData(element) {
        var drFrontId = element.id;
        var id = 'sdrn:e24:frontpage:front:element:' + drFrontId;
        var row = element.className.replace(/.*row\-(\d+).*/, '$1');

        var skinIcon = 'default';
        var image = element.querySelector('.df-img-container');

        if (image && image.className.indexOf('df-img-skin') > -1) {
            skinIcon = image.className.replace(/.*df\-img\-skin\-([^ ]+).*/, '$1');
        }

        var size = '1.0';

        TEASER_SIZES.forEach(function (teaserSize) {
            if (element.classList.contains(teaserSize[0])) {
                size = teaserSize[1];
            }
        });

        var teaserText = element.textContent.replace(/<[^>]+>/g, '').replace(/\n/g, '').trim();

        return {
            '@id': id,
            '@type': 'UIElement',
            contentId: id,
            elementType: CLICK_TRACKING_ID,
            duration: 0,
            skin: 'default',
            sampleSize: SAMPLE_SIZE,
            row: row || 0,
            skinIcon: skinIcon,
            size: size,
            teaserText: teaserText,
            page: {
                '@id': 'sdrn:e24:frontpage:front',
                '@type': 'Frontpage',
                url: window.location.href,
            }
        };
    }

    function trackClick(objectData, targetData, e) {
        var currentTime = Date.now();
        var duration = Math.floor((currentTime - startTime) / 1000);

        Pulse.ready(function(tracker) {
            var event = {
                type: 'Engagement',
                action: 'Click',
                intent: 'Open',
                target: targetData,
                object: objectData,
                scrollPosition: objectData.scrollPosition,
                duration: duration
            };

            tracker.track('trackerEvent', event, { resolveOnQueued: true })
                .then(function() { console.log('Click success') });
        });
    }

    function trackView(elements) {
        var currentTime = Date.now();
        var duration = Math.floor((currentTime - startTime) / 1000);
        var scrollPosition = getScrollPosition();

        pulse('tracker', function(tracker) {
            var event = {
                type: 'Engagement',
                action: 'Scroll',
                intent: 'View',
                origin: {
                    '@id': 'sdrn:e24:frontpage:front',
                    '@type': 'Frontpage',
                    url: window.location.href,
                },
                object: {
                    '@id': 'sdrn:e24:frontpage:front:element:' + VIEW_TRACKING_ID,
                    '@type': 'UIElement',
                    contentId: VIEW_TRACKING_ID,
                    elementType: VIEW_TRACKING_ID
                },
                elements: mapScrollPosition(elements, scrollPosition),
                scrollPosition: scrollPosition,
                duration: duration
            };

            tracker.track('trackerEvent', event);
        });
    }

    function parseViewedElement(element) {
        var elementData = getElementObjectData(element);
        if (!elementData) {
            return;
        }

        var targetData = getElementTargetData(element);
        if (!targetData) {
            return;
        }

        elementData.target = targetData;

        // Save to queue
        elementQueue.push(elementData);

        sendViewEvents();
    }

    function initViewTracking(elements) {
        trackVisibility(elements, function (element) {
            if (element.visible) {
                parseViewedElement(element.element);
            }
        }, 0, 0.7, true);
    }

    var sendViewEvents = _.debounce(
        function _sendViewEvents() {
            if (elementQueue.length === 0) {
                return;
            }

            var elements = elementQueue.splice(0);
            trackView(elements);
        },
        500
    );

    function initClickTracking(elements) {
        elements.forEach(function(el) {
            if (el.id.match(/^autorow/)) {
                return;
            }

            var objectData = getElementObjectData(el);

            if (!objectData) {
                return;
            }

            var targetData = getElementTargetData(el);

            el.addEventListener('click', function(e) {
                var linkEl = el.querySelector('a');

                if (!linkEl) {
                    return;
                }

                objectData.scrollPosition = getScrollPosition();

                // Send click-event
                trackClick(objectData, targetData, e);
            });
        });
    }

    var init = function(sampleSize) {
        if (sampleSize) {
            SAMPLE_SIZE = sampleSize;
        } else {
            SAMPLE_SIZE = 100;
        }

        var elements = Array.from(document.querySelectorAll(SELECTOR_ELEMENT));

        elements = elements.filter(function(elem) {
            return !!elem.querySelector('a');
        });

        initViewTracking(elements);
        initClickTracking(elements);
    }

    return init;
});

